import { connect } from 'react-redux';

import ConfirmationModal from './confirm_create_html_package_modal.jsx';

import {
  showModal,
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  addMediaLibraryAssetsToGridInSubpage 
} from 'zoomforth_codesbane_editor/action_creators/sections.grid.js';

import {
  beginUploadToTiles
} from 'zoomforth_codesbane_editor/action_creators/sections.grid.js';

import selectFilesWithOs from 'zoomforth_zfutils/select_files_with_os.js';

import SelectMediaFromLibrary 
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/select_media_from_library_container.jsx';

const mapStateToProps = () => {
  return {};
};


const mapDispatchToProps = (dispatch, { section, eid }) => (
  {
    onRequestClose: ()=> { 
      dispatch(closeModal()); 
    },
    onUploadClick: ()=> { 
      selectFilesWithOs({ multiple: false, accept: ['.zip'] }).done((files) => {
        dispatch(beginUploadToTiles(section, eid, files,  /* forceAssetType = */ 'html_package'));
        dispatch(closeModal());
      });
    },
    onSelectFromMediaLibraryClick: ()=> {
      dispatch(closeModal()); 
      dispatch(showModal(
        SelectMediaFromLibrary, 
        { 
          multiple: false,
          enabledMediaTypes: ['html_package'],
          enabledMediaWarningMsg: 'You may only select HTML Packages for this tile',
          onAssetsSelectDone: (assets) => {
            dispatch(addMediaLibraryAssetsToGridInSubpage(section, assets, { eid }));
          }
        }
      ));
    }
  }
);

const ConfirmCreateHtmlPackageForTileModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationModal);

ConfirmCreateHtmlPackageForTileModal.editorModalName = 'ConfirmCreateHtmlPackageForTileModal';

export default ConfirmCreateHtmlPackageForTileModal;
